module.exports = __webpack_public_path__ + "static/media/engine-icon.391f9d5e.png";